import { render, staticRenderFns } from "./AddManagement.vue?vue&type=template&id=fd4214b2&"
import script from "./AddManagement.vue?vue&type=script&lang=js&"
export * from "./AddManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports